'use client';

export * from './ReactNativeSVG';
export { default } from './ReactNativeSVG';
//# sourceMappingURL=index.js.map